/**
 * PlannerCalendar.calendar_type API values — keep aligned with PlannerCalendarSerializer.
 */

export const CALENDAR_TYPE_TODO = 'type_todo';
export const CALENDAR_TYPE_EVENT = 'type_event';
export const CALENDAR_TYPE_TASK = 'type_task';
export const CALENDAR_TYPE_BIRTHDAY = 'type_birthday';

export const DEFAULT_CALENDAR_TYPE = CALENDAR_TYPE_EVENT;

export const PLANNER_CALENDAR_TYPE_OPTIONS = [
  { value: CALENDAR_TYPE_EVENT, label: 'Event', tag: 'Event' },
  { value: CALENDAR_TYPE_BIRTHDAY, label: 'Birthday', tag: 'Birthday' },
  { value: CALENDAR_TYPE_TASK, label: 'Task', tag: 'Task' },
  { value: CALENDAR_TYPE_TODO, label: 'To-Do', tag: 'To-Do' },
];

/** @param {string | undefined | null} raw */
export function plannerCalendarTypeLabel(raw) {
  const v = raw && String(raw).trim() ? String(raw).trim() : DEFAULT_CALENDAR_TYPE;
  const opt = PLANNER_CALENDAR_TYPE_OPTIONS.find((o) => o.value === v);
  return opt ? opt.label : v;
}

/** Rótulo curto para badges na lista */
export function plannerCalendarTypeTag(raw) {
  const v = raw && String(raw).trim() ? String(raw).trim() : DEFAULT_CALENDAR_TYPE;
  const opt = PLANNER_CALENDAR_TYPE_OPTIONS.find((o) => o.value === v);
  return opt ? opt.tag : v;
}

/** Normalized planner calendar type (fallback matches backend default). */
export function plannerCalendarNormalizedType(cal) {
  const t = cal?.calendar_type;
  if (t != null && String(t).trim() !== '') return String(t).trim();
  return DEFAULT_CALENDAR_TYPE;
}

/** To-Do tab: only calendars created for daily to-do lists */
export function filterCalendarsForTodoTab(calendars) {
  const list = Array.isArray(calendars) ? calendars : [];
  return list.filter((c) => plannerCalendarNormalizedType(c) === CALENDAR_TYPE_TODO);
}

/** Events + Calendar tabs: hide to-do-only calendars */
export function filterCalendarsExcludingTodoType(calendars) {
  const list = Array.isArray(calendars) ? calendars : [];
  return list.filter((c) => plannerCalendarNormalizedType(c) !== CALENDAR_TYPE_TODO);
}
